import { FunctionComponent, ReactNode, useState } from 'react'
import { Button, Card } from 'react-bootstrap'

interface DashboardItemProps {
  heading: string
  children: ReactNode
  noContentBetween?: boolean
}

const DashboardItem: FunctionComponent<DashboardItemProps> = ({ heading, children, noContentBetween }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  return (
    <Card className={`h-100 ${!isOpen ? 'bg-transparent border-0' : ''}`}>
      <Card.Header className="d-flex justify-content-between ">
        <Button
          className="w-100 bg-transparent border-0 p-0 d-flex align-items-center"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="h4 mb-0 fw-normal">{heading}</span>
          <i className={`ms-auto fa ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
        </Button>
      </Card.Header>
      {isOpen && (
        <Card.Body
          className={`position-relative d-flex flex-column ${noContentBetween ? '' : 'justify-content-between'}`}
        >
          {children}
        </Card.Body>
      )}
    </Card>
  )
}

export default DashboardItem
